export const networkFieldsMapSF = {
  direction: 'in',
  Id: 'id'
}

export interface Network {
  id: string
}
